import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  // 移除組件樣式覆蓋，讓組件的 mt 和 py 設定生效
  // components: {
  //   MuiStack: {
  //     styleOverrides: {
  //       root: {
  //         marginTop: '0 !important',
  //         marginBottom: '0 !important',
  //         paddingTop: '0 !important',
  //         paddingBottom: '0 !important',
  //         '&.MuiStack-root': {
  //           marginTop: '0 !important',
  //           marginBottom: '0 !important',
  //           paddingTop: '0 !important',
  //           paddingBottom: '0 !important',
  //         }
  //       }
  //     }
  //   },
  //   MuiIconButton: {
  //     styleOverrides: {
  //       root: {
  //         marginTop: '0 !important',
  //         marginBottom: '0 !important',
  //         paddingTop: '0 !important',
  //         paddingBottom: '0 !important',
  //         '&.MuiIconButton-root': {
  //           marginTop: '0 !important',
  //           marginBottom: '0 !important',
  //           paddingTop: '0 !important',
  //           paddingBottom: '0 !important',
  //         }
  //       }
  //     }
  //   }
  // }
});

export default theme; 